import { SVGProps } from 'react'

type LogoVariant = 'default' | 'green'

interface LogoMobileProps extends SVGProps<SVGSVGElement> {
    variant?: LogoVariant
}

export const LogoMobile = ({ variant = 'default', ...props }: LogoMobileProps) => {
    const fill = variant === 'green' ? '#C5F73C' : '#223A32'
    const bg = variant === 'green' ? '#203A32' : 'transparent'

    return (
        <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="32" height="31" fill={bg} />
            <g clipPath="url(#clip0_483_983)">
                <path
                    d="M13.7293 0H0.5V0.10921C0.5 6.58213 3.93451 12.5345 9.46626 15.8059C14.73 18.9192 18.2651 24.6896 18.2651 31.2935H31.4943V31.1847C31.4943 24.7118 28.0598 18.7595 22.5277 15.4876C17.2643 12.3747 13.7293 6.60397 13.7293 0Z"
                    fill={fill}
                />
                <path
                    d="M23.2124 0H31.4944V1.98924C31.4944 4.74578 29.2778 6.98419 26.5471 6.98419H18.2651V4.99494C18.2651 2.2384 20.4818 0 23.2124 0Z"
                    fill={fill}
                />
                <path
                    d="M5.44725 24.3098H13.7293V26.2991C13.7293 29.0556 11.5126 31.294 8.782 31.294H0.5V29.3048C0.5 26.5482 2.71663 24.3098 5.44725 24.3098Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_483_983">
                    <rect width="31" height="31" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    )
}
